<template>
  <div v-loading="loading" element-loading-text="拼命加载中" class="detail-customer-year-frame-container default-table">
    <div class="card basic">
      <div class="title">
        <span>基础信息<i class="el-icon-refresh i-handel" @click="init"/></span>
      </div>
      <div style="text-align:center;margin: 20px;">
        <template v-if="yearFrameApplying">
          <span class="desc">{{ yearFrameApplying.type === MapType.TO_Y ? '申请' : '取消' }}年框中，待审核</span>
        </template>
        <template v-else>
          <el-button class="handel-apply" type="primary" size="mini" round @click="handelApply">
            {{ yearFrame ? '取消年框' : '申请年框' }}
          </el-button>
          <el-button v-if="yearFrame&&!combineId" class="handel-apply" type="primary" size="mini" round
                     @click="toSuspend">
            中止年框
          </el-button>
        </template>
      </div>
      <div class="item">
        <span>是否年框：</span>
        <span>{{ yearFrame ? '是' : '否' }}</span>
      </div>
      <template v-if="yearFrame">
        <div class="item" v-if="yearFrame.sign_begin">
          <span>签约时间：</span> <span>{{ yearFrame.sign_begin + '~' + yearFrame.sign_end }}</span>
        </div>
        <div class="item">
          <span>付款方式：</span>
          <span>
            {{
              yearFrame.apply && yearFrame.apply.pay_method && yearFrame.apply.pay_method_sub ? yearFrame.apply.pay_method + '-' + yearFrame.apply.pay_method_sub : (yearFrame.apply && yearFrame.apply.pay_method ? yearFrame.apply.pay_method : '-')
            }}
          </span>
        </div>
        <div class="item">
          <span>最高级别负责人：</span>
          <span>{{ yearFrame.apply ? yearFrame.apply.charge_person : '-' }}</span>
        </div>
        <div class="item"><span>职位：</span> <span>{{ yearFrame.apply ? yearFrame.apply.post : '-' }}</span></div>
        <div class="item"><span>客户等级：</span> <span>{{ yearFrame ? yearFrame.level_customer : '-' }}</span></div>
        <div class="item"><span>集团等级：</span> <span>{{ yearFrame ? yearFrame.level_combine : '-' }}</span></div>
        <div class="item"><span>投放金额：</span> <span>{{ yearFrame ? yearFrame.order_money : '-' }}</span></div>
        <div class="item"><span>返点金额：</span> <span>{{ yearFrame ? yearFrame.rebate_money : '-' }}</span></div>
        <div class="item"><span>优惠金额：</span> <span>{{ yearFrame ? yearFrame.discount_money : '-' }}</span></div>
        <div class="item policy-remark"><span>年框政策：</span> <span>{{ yearFrame.policy_alias || '-' }}</span></div>
      </template>
    </div>
    <div class="card apply-record">
      <div class="title">
        <div class="tab-table">
          <el-radio-group v-model="tabTableIndex" size="mini">
            <el-radio-button :label="MapTabIndex.APPLY">申请记录</el-radio-button>
            <el-radio-button :label="MapTabIndex.VALID">年框记录</el-radio-button>
          </el-radio-group>
          <a style="font-size: 12px;margin-left: 10px;color: #bebebe;">
            <i class="el-icon-info"/>下述表格内容为{{ tabTableIndex === MapTabIndex.APPLY ? '申请' : '年框' }}记录
          </a>
        </div>
        <el-link style="font-size: 12px;" @click="goYearFrame">链接：年框申请列表</el-link>
      </div>
      <table-apply v-if="tabTableIndex===MapTabIndex.APPLY" :key="`table-apply-${key}`" :customer-id="customerId"/>
      <table-valid v-else :key="`table-valid-${key}`" :customer-id="customerId"/>
    </div>
    <apply ref="apply" :show.sync="dialogApply" :customer="dialogApplyForm" :type="dialogApplyForm.type"
           @success="init"/>

    <el-dialog :title="`中止年框`" :visible.sync="dialogSuspendForm.show" width="520px" center>
      <div class="current-info" style="text-align: center">
        <p>请选择中止日期</p>
        <el-date-picker ref="refExecDatePacker" class="el-input-c" type="date"
                        v-model="dialogSuspendForm.suspend_date"
                        value-format="yyyy-MM-dd"
                        format="yyyy年MM月dd日"
                        placeholder="选择选择中止日期"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogSuspendForm.show=false">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSureSuspend">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {current, yearFrameSuspend} from "@/api/customerYearFrame";
import Apply from "../yearFrame/apply.vue";
import TableValid from "@/views/custom/components/detailCustomYearFrame/tableValid.vue";
import TableApply from "@/views/custom/components/detailCustomYearFrame/tableApply.vue";

const MapType = {
  TO_Y: 'TO_Y',
  TO_N: 'TO_N',
}
const MapStatus = {
  WAIT: 0,
  PASS: 1,
  REJECT: 2,
  CANCEL: 3,
}
const MapStatusShow = {
  [MapStatus.WAIT]: {label: '待审核', color: '#409eff'},
  [MapStatus.PASS]: {label: `通\u3000过`, color: '#67c23a'},
  [MapStatus.REJECT]: {label: '拒\u3000绝', color: '#f56c6c'},
  [MapStatus.CANCEL]: {label: '撤\u3000回', color: '#909399'},
}
const MapTabIndex = {
  VALID: 'valid',
  APPLY: 'apply',
}
const ModelYearFrame = {
  "type": null,
  "sign_begin": null,
  "sign_end": null,
  "policy_remark": null,
  "pay_method": null,
  "charge_person": null,
  "post": null,
  "phone": null,
}

export default {
  name: "detailCustomYearFrame",
  components: {TableApply, TableValid, Apply},
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
    customerName: {
      type: [String, Number],
      required: true
    },
    customer: {
      type: [Object],
      required: true
    },
  },
  data() {
    return {
      MapType,
      MapTabIndex,
      MapStatusShow,
      loading: false,
      yearFrame: {...{}, ...ModelYearFrame},
      yearFrameApplying: false,
      dialogApply: false,
      key: new Date().getTime(),
      dialogApplyForm: {},
      dialogSuspendForm: {
        show: false,
        record_id: false,
        suspend_date: false,
      },
      tableData: [],
      tabTableIndex: MapTabIndex.VALID,
      queryParams: {
        customer_id: [this.customerId],
        page: 1,
        page_size: 10,
        total: 0,
      }
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    combineId() {
      return this.customer && this.customer.combine ? this.customer.combine.id : null
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.key = new Date().getTime()
      this.loading = true
      await Promise.all([this.getBasic()])
      this.loading = false
    },
    refresh() {
      this.init()
    },
    async getBasic() {
      const response = await current({customer_id: this.customerId})
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.yearFrame = false
      if (response.model) {
        this.yearFrame = response.model.record_current || false
        this.yearFrameApplying = response.model.record_applying || false
      }
    },
    handelTabIndex(index) {
      this.tabTableIndex = index
    },
    handelApply() {
      if (this.yearFrame) {
        this.applyToN()
      } else {
        this.applyToY()
      }
    },
    applyToY() {
      const {combine} = this.customer
      this.dialogApply = true
      this.dialogApplyForm = {
        is_update: false,
        type: 'TO_Y',
        customer_id: this.customerId,
        customer_name: this.customerName,
        combine_id: combine ? combine.id : null,
        combine_name: combine ? combine.name : '-',
      }
    },
    applyToN() {
      const {combine} = this.customer
      const yearFrame = this.yearFrame
      this.dialogApply = true
      this.dialogApplyForm = {
        is_update: false,
        type: 'TO_N',
        record_id_cancel: this.yearFrame.id,
        customer_id: this.customerId,
        customer_name: this.customerName,
        combine_id: combine ? combine.id : null,
        combine_name: combine ? combine.name : '-',
        "sign_begin": yearFrame.sign_begin,
        "sign_end": yearFrame.sign_end,
        "policy_remark": yearFrame.policy_remark,
        "pay_method": yearFrame.pay_method,
        "charge_person": yearFrame.charge_person,
        "post": yearFrame.post,
        "phone": yearFrame.phone,
      }
    },
    toSuspend() {
      this.dialogSuspendForm = {
        show: true,
        record_id: this.yearFrame.id,
        suspend_date: new Date().toISOString(),
      }
    },
    goYearFrame() {
      const {href} = this.$router.resolve({name: 'yearFrameProposer', query: {hand: 'proposer'}});
      window.open(href, "_blank");
    },
    handleSureSuspend: async function () {
      const response = await yearFrameSuspend(this.dialogSuspendForm)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.dialogSuspendForm.show = false
      this.refresh()
    }
  }
}
</script>

<style lang="scss">
.detail-customer-year-frame-container {
  width: 100%;
  height: calc(100%);
  display: flex;
  justify-content: space-between;

  .el-button--text {
    padding: 0;
  }

  .handel-apply {
    padding: 4px 15px;
  }

  .card {
    padding: 12px 12px 12px 24px;
    border-radius: 6px;
    border: 1px dashed rgb(221, 221, 221);

    .title {
      position: relative;
      margin-bottom: 8px;
      color: rgb(50, 50, 50);
      line-height: 24px;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      display: flex;
      justify-content: space-between;

      &:after {
        content: "";
        position: absolute;
        bottom: 6.5px;
        left: -12px;
        width: 8px;
        height: 8px;
        background: rgb(224, 63, 61);
        border-radius: 2px;
      }

      .desc {
        font-size: 12px;
        color: rgb(224, 63, 61);
      }
    }
  }

  .basic {
    width: 250px;
    margin-right: 12px;
    text-align: left;
    line-height: 20px;

    span:first-child {
      font-weight: bolder;

    }
  }

  .apply-record {
    width: calc(100% - 290px);
  }

  .policy-remark {
    height: calc(100% - 150px);

    span:last-child {
      height: 100%;
      display: block;
      overflow-y: auto;
    }
  }

  .tab-table {
    span {
      cursor: pointer;
      font-size: 12px;
    }

    span:hover {
      color: #ff3176;
    }

    .active {
      font-size: 15px;
      color: #ff3176;
    }
  }
}
</style>
